import { createContext } from "react";

export const CommentaryContext = createContext<{
	fixedCommentary: boolean;
}>({
	fixedCommentary: false,
});
